import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { WIDGET_SIZES } from '@liveHelper/components/shared/WidgetContainer/WidgetContainer.styles'

export const ChattingWrapper = styled.div<{ isMobileWeb: boolean }>`
  position: relative;

  width: 100%;

  height: 100%;

  overflow: hidden;

  border-radius: var(--border-radius-md);

  ${({ isMobileWeb }) =>
    !isMobileWeb &&
    css`
      min-width: ${WIDGET_SIZES.expanded.default.width};
      max-height: 100vh;
      max-width: 100vw;
    `}/* Because of the animation to grow the chat container, we need to set a min-width to prevent the chat from shrinking to 0 width when the chat is minimized.
  The reason for this, is longer messages look very awkward when growing from a more minimized state to the chatting default width and height. */
`
